/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { InsetQuestion } from 'components/InsetQuestion'
import { Video } from 'components/Video'
import { Link } from '@ta-interaktiv/contentbricks'
import ReactPlayer from 'react-player'

const map_desktop =
  'https://api.mapbox.com/styles/v1/ta-interaktiv/ckuqpes1u1o3s17k9kmn9mlwf/static/9.6,46.6,8.2010,0,1/1280x650@2x?access_token=pk.eyJ1IjoidGEtaW50ZXJha3RpdiIsImEiOiJjaXNhNGFsdHAwMDB2Mm9wNWdlMTlqMTNuIn0.uj5aGvF3yvEM4V6kNdlbVg&attribution=false&logo=false'

// TODO Set the correct article ID here
const ARTICLE_ID = '276302512712'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} inverted />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header a'>
            <h1>Dieser Wolf kommt dem Menschen zu nahe</h1>
            <h2>
              M92 ist der Leitwolf des berüchtigsten Wolfsrudels der Schweiz.
              Der Rüde vom Piz Beverin sollte längst tot sein. Doch er lebt.
              Naturschützer sammeln für ihn Unterschriften, Bündner Bauern toben
              &ndash; und eine Hirtin erzählt erstmals von ihrer verstörenden
              Begegnung.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical very fitted segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Yann Cherix, Sebastian Broschinski</div>
            <div className='ta updated'>Aktualisiert am 26. November 2021</div>
          </div>
          <div className='ta text'>
            <p>
              Der Novemberschnee ist da. Auf dem Piz Beverin, 2998 Meter hoch,
              liegen 20 Zentimeter. Mit dem Schnee – das wissen alle hier in den
              Dörfern der Viamala – kommt der Rothirsch, der in tieferen Lagen
              nach Grünem sucht. Und mit dem Hirsch kommt auch der Wolf – und
              damit die Probleme.
            </p>
            <p>
              Das gilt besonders hier, auf halbem Weg zum San Bernardino hinauf.
              Zwischen Naturpark Beverin, Heinzenberg und Safiental hat sich das
              Beverinrudel breit gemacht. Berüchtigt ist es für seine
              zahlreichen Schafrisse, Angriffe auf Kälber und Esel; für seine
              Schlauheit, die meterhohe Elektrozäune überwindet. Und für seine
              mangelnde Menschenscheu. Während ein Grossteil der über 100 Wölfe
              in der Schweiz ganz{' '}
              <Link href='805178807363' allowWordWrap>
                natürlich Distanz zum Menschen hält
              </Link>
              , zeigen sich die Raubtiere vom Beverin vermehrt unbeeindruckt von
              Begegnungen mit dem Menschen.
            </p>

            <p>
              Fachleute sprechen von problematischem Verhalten. Für die Bündner
              Behörden ist das Leittier, M92, dafür verantwortlich. «Seit er
              hier ist, macht er Probleme», sagt Adrian Arquint, Vorsteher des
              Bündner Amts für Jagd und Fischerei. Der «Blick» schrieb vom
              frechsten Wolf der Schweiz, die Bauern der Region bezeichnen ihn
              als Plage und sind doch irgendwie fasziniert vom effizienten
              Jäger. Einer sagt: «So sehr ich ihn tot wünsche, er ist ein
              Sibesiech.»
            </p>
          </div>
        </div>
        <div className='ui  container'>
          <div className='img m92'>
            <img src={require('images/m92.jpg')} />
            <div className='source'>
              M92, das Leittier des Beverinrudels, mit Beute. Aufnahme einer
              Fotofalle, 2019. Amt für Jagd und Fischerei GR
            </div>
          </div>
        </div>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              M92 ist zum Politikum geworden. Bauern und Kanton wollen ihn
              abschiessen lassen, während Naturschützer mit einer
              Online-Unterschriftensammlung für dessen Leben kämpfen.
            </p>
            <InsetQuestion
              question='Wann darf ein Wolf geschossen werden?'
              id='Schiessen'
            >
              <>
                <p>
                  Mit der revidierten Jagdverordnung gilt seit diesem Sommer:
                  Wolfsrudel dürfen nach zehn gerissenen Schafen oder Ziegen
                  (mit Herdenschutz) reguliert werden. Bei grossen Nutztieren
                  wie Rindern oder Pferden reichen zwei Risse. In der Regel
                  beantragen die Kantone die Rudel-Regulierungen, das Bundesamt
                  für Umwelt (Bafu) entscheidet. Schadenstiftende Einzelwölfe
                  können die Kantone ohne explizite Zustimmung des Bafu
                  abschiessen.{' '}
                </p>
                <div className='chartwrapper'>
                  <div className='chart half'>
                    <div className='charttitle'>
                      Gerissene Nutztiere in Graubünden
                    </div>
                    {/* <div className='chartsub'>2020 und 2021 bis Oktober</div> */}
                    <img src={require('images/risse.jpg')} />
                    <div className='chartsource'>
                      Quelle:{' '}
                      <a
                        href='https://www.gr.ch/DE/institutionen/verwaltung/diem/ajf/grossraubtiere/aktuell/news/Seiten/202111081.aspx'
                        target='_blank'
                        rel='noreferrer'
                      >
                        Kanton Graubünden
                      </a>
                    </div>
                  </div>{' '}
                  <div className='chart half'>
                    <div className='charttitle'>
                      In der Schweiz als Wolfsrisse entschädigte Nutztiere
                    </div>{' '}
                    <img src={require('images/charts_risse.svg')} />
                    <div className='chartsource'>
                      Quelle:{' '}
                      <a
                        href='https://www.kora.ch/index.php?id=292'
                        target='_blank'
                        rel='noreferrer'
                      >
                        KORA
                      </a>
                    </div>
                  </div>
                </div>
              </>
            </InsetQuestion>
            <p>
              Wegen M92 sitzt eine junge Frau an ihrem Küchentisch und hadert.
              Sie will ihre Geschichte erzählen. Jene aus dem vergangenen
              Sommer, als sie, die Hirtin, oben auf einer Alp zwei verstörende
              Begegnungen mit dem Beverinrudel hatte. Wochenlang getraute sie
              sich danach nachts nicht mehr alleine hinaus. «Das vergisst man
              nicht einfach so», sagt sie.
            </p>
            <p>
              Sie hadert, weil da auch noch eine andere Geschichte ist; jene,
              die erst nach der Wolfsbegegnung begann. Die Ereignisse am Beverin
              riefen schweizweit die Medien auf den Plan. Alle wollten von der
              Hirtin wissen, wie es ist, von Wölfen umzingelt, von ihnen
              angeknurrt zu werden. Sie hat sich damals nicht öffentlich
              geäussert. Bis heute.
            </p>
            <p>
              Obwohl ihr Name nie bekannt wurde, wusste man im kleinräumigen
              Bündnerland bald, um wen es ging. Sie habe Todesdrohungen
              erhalten, behauptet sie. Dazu anonyme, gehässige Nachrichten von
              Wolfsfreunden via Facebook, die ihr vorwarfen, den Wolf schlecht
              zu machen, absichtlich die Situation zu dramatisieren. Ihr Bild
              und ihren Namen will sie darum noch immer nicht öffentlich machen.
              Ihre Geschichte aber schon. «Alle sollen erfahren, wie es wirklich
              war.»
            </p>
            <div className='img'>
              <Video
                filename='211123_Wolf_FINAL_ap.mp4'
                poster='Teaserbild_A.png'
              />

              <div className='source'>
                Wie lässt sich das Wolfproblem lösen? Behörden, ein Bauer und
                ein Tierschützer antworten. Video: Tamedia
              </div>
            </div>
            <p>
              Kein anderes Tier im Alpenraum ruft ähnlich starke Reaktionen
              hervor. Seit der Wolf vor 25 Jahren in die Schweiz zurückkehrte,
              haben sich Fronten gebildet. Besonders deutlich kamen die{' '}
              <Link href='624175793985' allowWordWrap>
                Trennlinie im Abstimmungskampf
              </Link>{' '}
              um das revidierte Jagdgesetz 2020 zum Vorschein. Obwohl es um
              viele weitere Tiere ging, um eine längst fällige Revision eines
              Gesetzes von 1986, hat der Wolf die Debatte dominiert. Man war für
              oder gegen den Wolf. Und damit für oder gegen das Jagdgesetz.
            </p>
            <p>
              Hier die Seite der Bauern, die tobend{' '}
              <Link href='847419954323' allowWordWrap>
                von ihren toten und schwerverletzten Schafen berichten
              </Link>{' '}
              und den Behörden Untätigkeit vorwerfen; dort Naturschützer, die
              den Wolf zum Symbol einer intakten Natur erkoren haben und
              vehement um jedes Tier kämpfen. Für Letztere ist der Wolf ein
              faszinierender Bote der Natur, ein Versprechen auf pure Wildheit.
              Für die Mehrheit der Bauern hingegen: einer, der ihre Existenz
              bedroht.
            </p>
            <div className='chart'>
              <div className='charttitle'>
                Wer sind die wichtigen Akteure rund um den Wolf?
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted segment'>
        <div className='ui container'>
          <div className='organigram'>
            <img
              src={
                window.innerWidth < 600
                  ? require('images/organigram-01_mob.jpg')
                  : require('images/organigram-01.jpg')
              }
            />
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Urs Leugger-Eggimann ist Naturschützer. Er steht auf der Seite des
              Wolfs, aber wohl auch irgendwo zwischen den Polen. Denn er sagt:
              «Mit der Regulierung von Wölfen, die trotz Schutzmassnahmen grosse
              Schäden anrichten oder sich problematisch verhalten, sind wir
              einverstanden. Und natürlich müssen wir berücksichtigen, dass
              dort, wo der Wolf sich ausbreitet, auch Menschen leben und
              arbeiten.»
            </p>
            <p>
              Leugger-Eggimann ist Geschäftsführer von Pro Natura. Er will den
              Wolf weder überhöhen noch verteufeln. «Man muss gerade bei der
              Wiederausbreitung eines solchen grossen Beutegreifers den Kontext
              sehen, die Natur im Zusammenspiel.» Das sei beim Wolf, der seit
              seiner Rückkehr neue Fragen aufwerfe, besonders wichtig. «Wir
              lernen ständig dazu.» Leugger-Eggimann war als Präsident des
              Nein-Komitees massgeblich daran beteiligt, dass{' '}
              <Link href='505268075828' allowWordWrap>
                die Revision des Jagdgesetzes 2020 vom Volk abgelehnt wurde
              </Link>
              .
            </p>
            <p>
              Gut ein Jahr später ging es sachlicher zu und her. Offenbar haben
              alle Beteiligten tatsächlich dazugelernt. Innert nur weniger
              Monate hat der Bundesrat eine Verordnung ändern lassen und durch
              die Vernehmlassung gebracht. Das Ziel: die Neuerungen auf den
              Alpsommer 2021 hin in Kraft zu setzen.
            </p>
            <InsetQuestion
              question={<>Was ist Herden&shy;schutz?</>}
              id='Herdenschutz'
            >
              <>
                <p>
                  Für Bund und Naturschutzorganisationen der Schlüssel: Schutz
                  durch Zäune und/oder Herdenschutzhunde. Beide Massnahmen
                  werden gefördert und subventioniert, gerissene Nutztiere
                  entschädigt. Während die Bundesbehörden den Herdenschutz als
                  generell gut umsetzbar einschätzen, schlagen besonders die
                  Bergbauern Alarm. Bis zu einem Drittel der Alpwirtschaft seien
                  bedroht. In hohen, humus armen Regionen ist das Aufstellen von
                  Zäunen aufwendig. Und die Arbeit mit Herden&shy;schutzhunden
                  ist kompliziert. Der Aufwand werde, so die Bauern, zu gross.{' '}
                </p>
                <div className='chart herdenschutz'>
                  <img src={require('images/herdenschutz.jpg')} />
                </div>
              </>
            </InsetQuestion>
            <p>
              Am 30. Juni verkündete dann der Bundesrat die neuen Regeln. Neben
              dem ausgebauten Herdenschutz wurde auch die Regulierung – also das
              Abschiessen von mehreren Wölfen aus einem Rudel – erleichtert. Urs
              Leugger-Eggimann von Pro Natura und alle anderen
              Naturschutzorganisationen trugen diesen gut schweizerischen
              Kompromiss mit.
            </p>
            <p>
              Der Mann von Pro Natura anerkennt heute, dass mit der Ausbreitung
              des Wolfs je nach Situation stärker und schneller reagiert werden
              müsse. «Besonders bei einem so cleveren Rudel wie dem des Beverin,
              das wiederholt zumutbare Herdenschutzmassnahmen überwindet.» Ein
              solches Verhalten sei, sagt Urs Leugger-Eggimann, auch nicht in
              ihrem Sinn. Er kann darum nachvollziehen, dass das Bundesamt für
              Umwelt (Bafu) im September entschied, den Abschuss dreier
              Jungwölfe vom Beverin zu bewilligen.
            </p>
            <p>
              M92 aber, der Vater, sollte nicht angetastet werden. «Ein
              Dämpfer», wie die Bündner Behörden danach verlauten liessen. Doch
              für die Bundesbehörden mangelte es an Nachweisen, konkret: an
              DNA-Proben, die dem Rüden genügend Risse zuordnen konnten. In zwei
              Jahren müssen es 60 Prozent der Risse sein. Verletzte Schafe
              werden nicht gezählt. Rinder und Esel ebenfalls nicht.
            </p>

            <p>
              Für Urs Leugger-Eggimann von Pro Natura kommt noch ein weiterer
              Aspekt hinzu. «Bei einem Leitwolf sollte ein Abschuss besonders
              sorgfältig abgewogen werden und die Ausnahme bleiben. Denn dessen
              Eliminierung kann ein Rudel auseinanderfallen lassen.» Der
              Naturschützer spricht davon, dass einzelne herumstreunende
              Rudelmitglieder allenfalls noch mehr Schaden in der Region
              anrichten könnten.
            </p>
            <p>
              Beim Kanton ist man anderer Meinung. Adrian Arquint vom Bündner
              Amt für Jagd und Fischerei sieht im M92 den Grund allen Übels. Und
              gleichzeitig die Lösung des Problems am Beverin. Der Leitrüde sei
              es, der dem Nachwuchs das problematische Verhalten vorlebe, es ihm
              beibringe.
            </p>
            <p>
              Was dies bedeutet, weiss die Hirtin. Auch Monate nach jenem Tag im
              August, als ihr der Wolf begegnete, erinnert sie sich genau an
              jedes Detail.{' '}
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted segment '>
        <div className='videoplayer'>
          <ReactPlayer
            className='react-player'
            width='100%'
            url={require('images/211118_30_Sekundenteaser_ap.mp4')}
            playing
            playsinline
            muted
            loop
            controls={false}
          />
        </div>{' '}
        <div className='source video'>
          Aufnahmen mit einem Nachtsichtgerät. Jagd des Beverin-Rudels auf
          Rothirsche, Zillis, April 2021. Quelle: Thomas Dolf
        </div>
        {/* </div> */}
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Es ist ihre zweite Saison auf der Alp. Erst im Jahr davor hatte
              die Frau in den Zwanzigern zum ersten Mal die Verantwortung für
              die 175 Kühe übernommen; Braunvieh, Limousin, Simmentaler. Die
              Arbeit als Hirtin ist körperlich anspruchsvoll &ndash; und einsam.
              «Aber ich liebe es», sagt sie. Und sie macht es offenbar gut. Ihre
              Arbeitgeber, die in einer privaten Alpgenossenschaft
              zusammengeschlossenen Bauern, haben nichts zu nörgeln.
            </p>
            <p>
              Die Hirtin erzählt vom strahlenden Sonnenschein, der an diesem Tag
              herrscht. Der Wolf, der Nebel oder Dunkelheit bevorzugt, wird sich
              an diesem Nachmittag auf offenem Gelände einem Menschen nähern.
              Nur ein selbstbewusstes, erfahrenes Tier tut so etwas.
            </p>
            <p>
              «Ich war auf der Weide, werkelte an einer Wasserleitung am Boden
              herum, als ich plötzlich ein Knurren hinter mir hörte.» Sie dreht
              sich um und sieht einen Wolf vor sich. Ob es der Leitrüde ist,
              kann sie nicht sagen. «Er war jedenfalls gross und keine zehn
              Meter von mir entfernt.» Ihr Hund, der normalerweise stets an
              ihrer Seite bleibt, versteckt sich hinter ihr. Wen der Wolf
              anknurrt, ist unklar. Von den Rufen der Hirtin lässt er sich
              jedoch nicht beeindrucken. Er blickt sie stumm an. «Wölfe schauen
              dir immer direkt in die Augen.» Nach ein paar Minuten zieht er
              wieder davon und lässt einen verstörten Hund und eine
              konsternierte Sennerin zurück. Es sollte nicht bei dieser
              Begegnung bleiben.
            </p>
            <InsetQuestion
              question={<>Wie hat sich der Wolf aus&shy;gebreitet?</>}
              id='Verbreitung'
            >
              <>
                <p>
                  Die Art wurde in weiten Teilen Europas im 20. Jahrhundert
                  ausgerottet - auch in der Schweiz. Erst 1995 wurde der Wolf
                  hierzulande wieder heimisch. Sie kamen aus Italien, wo sie nie
                  ganz verschwunden waren. Das Raubtier ist geschützt und findet
                  im Alpenbogen mit seine vielen Rothirschen, seiner Leibspeise,
                  ideale Bedingungen vor.
                </p>
                <div className='chartwrapper'>
                  <div className='chart half'>
                    <div className='charttitle'>Wolfbestand in der Schweiz</div>{' '}
                    <div className='chartsub'>inkl. Welpen und Toten</div>
                    <img src={require('images/charts_bestand.svg')} />
                    <div className='chartsource'>
                      Quelle:{' '}
                      <a
                        href='https://www.kora.ch/index.php?id=292'
                        target='_blank'
                        rel='noreferrer'
                      >
                        KORA
                      </a>
                    </div>
                  </div>
                  <div className='chart half'>
                    <div className='charttitle'>Wolfsrudel in der Schweiz</div>
                    <div className='chartsub'>&nbsp;</div>

                    <img src={require('images/charts_rudel.svg')} />
                    <div className='chartsource'>
                      Quelle:{' '}
                      <a
                        href='https://www.kora.ch/index.php?id=292'
                        target='_blank'
                        rel='noreferrer'
                      >
                        KORA
                      </a>
                    </div>
                  </div>
                </div>
              </>
            </InsetQuestion>{' '}
            <p>
              Was zu einer verängstigten Hirtin führen sollte, beginnt drei
              Jahre zuvor mit einem Grenzübertritt, über den die Behörden nur
              Vermutungen anstellen können. Ein einzelner Wolf soll Anfang 2018
              irgendwo von Italien herkommend in die Schweiz eingedrungen sein.
              Im Rheinwald gleich hinter dem San Bernardino findet das Tier
              perfekte Bedingungen vor: viel Platz und viele Rothirsche, seine
              Leibspeise. Vor allem trifft er auf ein Weibchen. Die Behörden
              bezeichnen das Paar fortan als M92 und F37. M und F fürs
              Geschlecht, durchnummeriert nach Ankunft. Der Rüde vom Beverin
              muss sich also in einem Gebiet behaupten, das bereits von
              Dutzenden Artgenossen besetzt ist.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted segment '>
        <div className='ui  container'>
          <div className='group'>
            <div className='chartwrapper switzerland'>
              <div className='charttitle'>Wolfsrudel in Graubünden</div>
              <div className='chartkey'>
                <div className='swatch' />
                Revier eines Rudels
              </div>

              <img src={require('images/switzerland-01.png')} />
            </div>
            <div className='chartwrapper graubuenden'>
              <img className='map' src={map_desktop} />
              <div className='chart source'>
                Quelle:{' '}
                <a href='https://www.kora.ch' target='_blank' rel='noreferrer'>
                  kora.ch{' '}
                </a>
                , © <a href='https://www.mapbox.com/about/maps/'>Mapbox</a> ©{' '}
                <a href='http://www.openstreetmap.org/copyright'>
                  OpenStreetMap
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='ui vertical segment '>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Im Bündnerland sind zu diesem Zeitpunkt zwei Rudel heimisch, am
              Calanda und beim Ringelspitz. Und Rudel sind eine ganze andere
              Sache als Einzeltiere. Im Gegensatz zu umherziehenden Wölfen
              bleibt es vor Ort, sorgt für viel mehr Risse, mehr Schäden. 3,5
              Kilogramm Fleisch frisst ein ausgewachsener Wolf pro Tag.
              Hochgerechnet auf ein Jahr, entspricht dies ungefähr 16
              Rothirschen. Sein Hunger ist besonders gross, wenn Nachwuchs da
              ist. Die jungen Wölfe müssen gefüttert werden.
            </p>
            <InsetQuestion question='Was frisst der Wolf?' id='Fressen'>
              <>
                <p>
                  Etwa 3,5 Kilogramm Fleisch pro Tag, meist Rothirsche. Aber
                  auch Rehe, Gämsen oder Wildschweine, vornehmlich Frischlinge.
                  Wölfe könne aber auch tagelang keine Nahrung zu sich nehmen.
                  Wenn nötig, fressen sie auch Aas. Wölfe gehen sparsam mit
                  ihren Energiereserven und versuchen Verletzungen vorzubeugen.
                  Daher jagen sie vornehmlich junge, alte, geschwächte oder
                  verletzte Tiere. Haus- und Nutztiere gehören nicht zur
                  natürlichen Beute. Der opportunistische Jäger hat aber
                  gelernt, dass gerade ungeschützte Schafe einfach zu erlegen
                  sind.
                </p>
                <div className='chart nahrung'>
                <div className='charttitle'>Nahrung der Wölfe</div>
                    <div className='chartsub'>Auswertung von 2000 Wolfslosungen in der Lausitz (2001–2009)</div>
                <img src={require('images/nahrung.png')} />
                <div className='chartsource'>
                      Quelle:{' '}
                      <a
                        href='https://www.nabu.de/tiere-und-pflanzen/saeugetiere/wolf/wissen/15572.html'
                        target='_blank'
                        rel='noreferrer'
                      >
                        Nabu
                      </a>
                    </div>
                </div>
              </>
            </InsetQuestion>{' '}
            <p>
              Das ist im Mai 2019 am Beverin der Fall. M92 hat zusammen mit
              seiner Partnerin F37 neun Welpen gezeugt und sorgt für 32
              nachgewiesene Risse, 16 tote Ziegen. Mindestens dreimal soll der
              Superjäger einen Elektrozaun übersprungen haben. Während die
              Bauern ihre toten Nutztiere auf den Wiesen und in den Wäldern
              zusammensuchen , wird ein veröffentlichtes Video der
              herumtollenden Beverin-Welpen zum viralen Hit.
            </p>
            <div className='img'>
              <Video
                filename='211118_Jungtiere_ap.mp4'
                poster='Teaserbild_B.png'
              />

              <div className='source'>
                Die Beverin-Jungwölfe beim Herumtollen. Das Video ging 2019
                viral.
                <br />
                Quelle: Amt für Jagd und Fischerei GR, Video: Tamedia
              </div>
            </div>
            <p>
              Derweil bewilligt das Bafu den Abschuss von vier dieser Jungwölfe.
              Die Umweltverbände akzeptieren den Entscheid, zu offensichtlich
              ist das problematische Verhalten des Rudels. Der Chef aber, M92,
              bleibt verschont. Sein Status als Vatertier schützt ihn. Die
              Massnahme, die die opportunistischen Jäger wieder scheuer machen
              sollte, wirkt jedoch nicht lange nach. Bereits ein Jahr später,
              2020, reissen sie ein Kalb, erstmals auch einen Esel. DNA-Proben
              beweisen die Beteiligung von M92. Einen weiteren Antrag des
              Kantons, das Rudel zu regulieren, lehnen die Behörden in Bern ab.
              Begründung: Artenschutz.
            </p>
            <p>
              Im August 2021 kommt es schliesslich zum zweiten
              Aufeinandertreffen der Hirtin mit dem Wolf.
            </p>
            <p>
              Die erste Wolfsbegegnung auf der offenen Wiese liegt eine Woche
              zurück. Es ist wieder Nachmittag, wieder scheint die Sonne. Eine
              Stunde Fussmarsch von ihrer Hütte entfernt, kontrolliert die junge
              Frau ihren Zaun. Ihr Hund ist dabei, wie immer. «Und dann standen
              sie plötzlich da, leicht über mir.» Drei Wölfe umzingeln die Frau
              und den Hund. Und dann habe einer angegriffen, erzählt sie,
              versucht, den Hund in den Nacken zu beissen. «Ich schrie und
              schrie, fuchtelte mit dem Stock.» Die Wölfe lassen vom Hund ab,
              verfolgen aber die Hirtin, die sich nun ruhig, aber bestimmt
              zurückzieht. Nicht rennen. Nicht den Jagdinstinkt wecken. Das
              weiss auch die Frau, die in den Bergen aufgewachsen ist.
            </p>
            <p>
              Am Abend geht sie noch einmal ins Gelände, diesmal in Begleitung
              von zwei befreundeten Bauern. Sie sehen in der Ferne das Rudel,
              etwa zwölf Tiere. Sicher mit dabei: M92.
            </p>
            <p>
              Am nächsten Tag kommen die herbeigerufenen Wildhüter zur Hütte.
              Sie werden dies in den nächsten Wochen täglich tun, vor allem
              dann, wenn die junge Frau alleine ins Gelände muss. Personenschutz
              für eine Hirtin. Es ist noch nicht vorbei.
            </p>
          </div>
        </div>
      </div>
      <div className='ui vertical very fitted segment '>
        <div className='img full beverin'>
          <img src={require('images/beverin.jpg')} />
          <div className='source'>
            Der Naturpark Beverin. Heimat des berüchtigten Wolfsrudels und
            beliebtes Wandergebiet. Foto: Beat Schaufelberger
          </div>
        </div>
      </div>

      <div className='ui vertical segment '>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Schweizer Wanderer melden Ende August, im Naturpark Beverin zwei
              Wölfe in unmittelbarer Nähe gesehen zu haben, wenig später, von
              Jungwölfen verfolgt worden zu sein. Sie informieren die Polizei.{' '}
              <Link href='306012230138' allowWordWrap>
                Die Aufregung ist gross. Touristen!
              </Link>{' '}
              Es ist eine nächste Eskalationsstufe. In Graubünden, diesem vom
              Tourismus so sehr geprägten Kanton, hatte man sich genau davor
              gefürchtet.
            </p>
            <p>
              Der Gemeindepräsident der Gemeinde Muntogna da Schons am
              Schamserberg, selbst Bauer, sprach danach von einer völlig
              unhaltbaren Situation. Während die Gruppe Wolf Schweiz
              beschwichtigte und lieber darauf hinwies, dass in Bezug auf die
              Ereignisse am Piz Beverin Medien und Behörden vereinzelt «klar
              tatsachenwidrig» von Wolfsangriffen auf Menschen sprachen.
            </p>
            <InsetQuestion
              question='Kann der Wolf dem Menschen gefährlich werden?'
              id='Menschen'
            >
              <>
                137 Wölfe leben derzeit in der Schweiz (Stand Oktober 2021).
                Dass man einem dieser Raubtiere begegnet, ist derzeit also
                verschwindend klein. Von Natur aus ist der Wolf menschenscheu.
                Laut einer norwegischen Studie sind in Westeuropa von 2002 bis
                2020 acht Wolfsangriffe nachgewiesen – keiner endete tödlich.
                Hunde nimmt das Raubtier aber als Konkurrenten wahr. Sollte es
                zu einer Begegnung kommen, empfehlen Experten, mit lauter Stimme
                Präsenz zu markieren; nicht wegrennen, sich langsam entfernen,
                ohne zu starren.{' '}
                <div className='chart verhalten'>
                  <div className='chartsub'></div>
                  <img src={require('images/verhalten.png')} />

                </div>
              </>
            </InsetQuestion>
            <p>
              Urs Leugger-Eggimann von Pro Natura sagt: «Ich verstehe die Angst
              der Hirtin. Aber: Die Aggression des Wolfs ging offenbar gegen den
              Hund.» Und im Fall der Touristen könne von keinem aggressiven
              Verhalten ausgegangen werden.
            </p>
            <p>
              Weniger locker sieht es Adrian Arquint. Der Bündner Amtsvorsteher
              bezeichnet die Lage als ernst. «Vor allem im Rudelverband ist ein
              solches Verhalten der Beginn einer Habituierung, die problematisch
              enden kann.» Die Bündner prüfen darum den Entscheid des Bafu und
              unter Umständen den Gang vor das Verwaltungsgericht.
            </p>
            <p>
              «Der Abschuss von M92 zum richtigen Zeitpunkt wäre sinnvoll», sagt
              Arquint. In anderen Worten: M92 soll sterben. Endlich.
            </p>
            <p>
              Für das Bundesamt für Umwelt (Bafu) ist das Vorgehen des Kantons
              «ein normales Verfahren». Doch für die Bundesbehörden sei ein
              Abschuss von Elterntieren nur im Ausnahmefall und unter bestimmten
              Bedingungen erlaubt. «Diese Bedingungen waren beim Beverinrudel
              nicht gegeben.» Das Bafu verweist aber noch einmal darauf, dass
              auf der Basis des Jagdgesetzes und der per Mitte Juli 2021
              revidierten Jagdverordnung dem Anliegen des Kantons entsprochen
              worden sei, drei Jungwölfe abzuschiessen.
            </p>
            <p>
              Zweimal geschah dies mittlerweile: am 8. September, nur zwei Tage
              nach der Bewilligung. Einen dritten Abschuss haben die Bündner
              Behörden also noch frei. Bis März bleibt Zeit. Die Wildhüter
              werden warten und erst schiessen, wenn das Rudel in die Nähe einer
              Siedlung, eines Stalls kommt. Der Lerneffekt soll möglichst gross
              sein, die Botschaft klar: Kommt ja nicht in die Nähe der Menschen!
            </p>
            <p>
              Die Wölfe des Beverinrudels werden aber genau dies tun. Dann, wenn
              der grosse Schnee kommt. M92 wird ihnen den Weg zeigen. Ihm wird
              nichts passieren. Bis auf weiteres.
            </p>
          </div>
        </div>
      </div>

      <div style={{ clear: 'both' }} />
      <Footer
        articleId={ARTICLE_ID}
        credits={[
          [
            'Konzept, Recherche, Umsetzung',
            'Yann Cherix, Sebastian Broschinski'
          ],
          [
            'Quellen',
            '<a href="https://www.kora.ch/">kora.ch</a>, <a href="https://www.gr.ch/DE/institutionen/verwaltung/diem/ajf/Seiten/home.aspx">Amt für Jagd und Fischerei GR</a>'
          ]
        ]}
      />
    </div>
  )
}
